<template>
  <div class="team-single">
    <div class="page-header">
      <div class="header-wrapper">
        <img :alt="team.name" :src="imgCoverDataUrl">
        <div class="overlay-mask">
          <div class="container">
            <div class="roster" v-if="team.members">
              <h6>membros do time</h6>
              <div class="members-list">
                <div class="member" v-for="user in team.members" :key="user.slug">
                  <UserCard :user="user"></UserCard>
                  <b-btn
                    @click.stop.prevent="kickPlayer(user.slug)"
                    class="kick-player"
                    size="sm"
                    variant="danger"
                    v-if="team.user_has_admin_access"
                  >
                    <i class="fas fa-trash"></i>
                  </b-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stats-bar">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-3"></div>
          <div class="col-12 col-md-9">
            <div class="stats-bar-content">
              <div class="stats-box">
                <div class="stat-box" v-b-tooltip.hover title="Partidas">
                  <p class="heading">PARTIDAS</p>
                  <p class="title">{{ team.lobby_count }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="Média de frags / mortes">
                  <p class="heading">KDR do time</p>
                  <p class="title">{{ team.kdr }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="Dano médio por Round">
                  <p class="heading">ADR</p>
                  <p class="title">{{ team.adr }}</p>
                </div>
                <div class="stat-box" v-b-tooltip.hover title="considerando as últimas 7 partidas">
                  <p class="heading">NÍVEL QUEOTA</p>
                  <p class="title">{{teamLevel}}</p>
                </div>
                <div
                  v-if="team.gamersclub_level"
                  class="stat-box"
                  v-b-tooltip.hover
                  title="Nível na Gamersclub (informado pelo time)"
                >
                  <p class="heading">Level GC</p>
                  <p class="title">{{ team.gamersclub_level }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="profile-avatar-container">
            <b-img
              class="profile-image"
              thumbnail
              rounded="circle"
              fluid
              :src="imgDataUrl"
              :alt="team.name"
            />
            <div class="profile-avatar-actions" v-if="team.user_has_admin_access">
              <a
                class="btn"
                @click="avatarToggleShow"
                v-if="team.user_has_admin_access"
              >alterar avatar</a>
              <a
                class="btn"
                @click="coverToggleShow"
                v-if="team.user_has_admin_access"
              >alterar cover</a>
            </div>
            <div class="profile-avatar-badges">
              <!-- <div class="premium-badge" v-b-tooltip.hover title="usuário beta">
                <i class="fas fa-flask"></i>
              </div>-->
            </div>
          </div>

          <h1 class="team-name">{{team.name}}</h1>

          <div class="social-media-links">
            <a :href="team.social_facebook" v-if="team.social_facebook" target="_blank">
              <i class="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </a>
            <a :href="team.social_twitter" v-if="team.social_twitter" target="_blank">
              <i class="fab fa-twitter"></i>
              <span>Twitter</span>
            </a>
            <a :href="team.social_website" v-if="team.social_website" target="_blank">
              <i class="fas fa-external-link-alt"></i>
              <span>Site</span>
            </a>
            <a :href="team.social_instagram" v-if="team.social_instagram" target="_blank">
              <i class="fab fa-instagram"></i>
              <span>Instagram</span>
            </a>
            <a :href="team.social_twitch" v-if="team.social_twitch" target="_blank">
              <i class="fab fa-twitch"></i>
              <span>Twitch</span>
            </a>
            <a :href="team.social_gamersclub" v-if="team.social_gamersclub" target="_blank">
              GC
              <span>Gamersclub</span>
            </a>
          </div>

          <my-upload
            field="img"
            v-model="avatarShow"
            v-if="team.user_has_admin_access"
            :width="500"
            :height="500"
            langType="pt-br"
            noCircle
            @crop-success="avatarCropSuccess"
            @crop-upload-success="avatarCropUploadSuccess"
            @crop-upload-fail="avatarCropUploadFail"
            :url="avatarUploadUrl"
            :params="avatarParams"
            :headers="avatarHeaders"
            img-format="jpg"
          ></my-upload>

          <my-upload
            field="img"
            v-model="coverShow"
            v-if="team.user_has_admin_access"
            :width="1500"
            :height="500"
            langType="pt-br"
            noCircle
            @crop-success="coverCropSuccess"
            @crop-upload-success="coverCropUploadSuccess"
            @crop-upload-fail="coverCropUploadFail"
            :url="coverUploadUrl"
            :params="coverParams"
            :headers="coverHeaders"
            img-format="jpg"
          ></my-upload>

          <b-btn v-if="false" v-b-modal.modal1>Launch demo modal</b-btn>
          <b-modal id="modal1" title="Bootstrap-Vue">
            <p class="my-4">Hello from modal!</p>
          </b-modal>

          <div v-if="team.user_has_admin_access">
            <b-button block v-b-modal.modalEditTeam>Editar time</b-button>
            <b-modal id="modalEditTeam" title="Editar time" ref="modalEditTeam" @ok="handleEditOk">
              <form @submit.stop.prevent="handleEditSubmit">
                <b-form-group description label="Nome do Time">
                  <b-form-input v-model="team.name" type="text" required maxlength="50" placeholder></b-form-input>
                </b-form-group>
                <b-form-group description label="TAG para dentro do jogo">
                  <b-form-input v-model="team.tag" type="text" required maxlength="20" placeholder></b-form-input>
                </b-form-group>
                <b-form-group description label="Senha para novos jogadores">
                  <b-form-input
                    v-model="team.secret_code"
                    type="text"
                    maxlength="30"
                    required
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group description label="Sobre o time">
                  <b-form-input
                    v-model="team.about"
                    type="text"
                    required
                    maxlength="250"
                    placeholder
                  ></b-form-input>
                </b-form-group>
                <b-form-group description label="Email do Responsável">
                  <b-form-input
                    v-model="team.email"
                    type="text"
                    required
                    maxlength="150"
                    placeholder
                  ></b-form-input>
                </b-form-group>

                <b-form-group description label="Facebook (link)">
                  <b-form-input
                    v-model="team.social_facebook"
                    type="url"
                    maxlength="150"
                    placeholder="https://facebook.com/USUARIO"
                  ></b-form-input>
                </b-form-group>

                <b-form-group description label="Twitter (link)">
                  <b-form-input
                    v-model="team.social_twitter"
                    type="url"
                    maxlength="150"
                    placeholder="https://twitter.com/USUARIO"
                  ></b-form-input>
                </b-form-group>

                <b-form-group description label="Instagram (link)">
                  <b-form-input
                    v-model="team.social_instagram"
                    type="url"
                    maxlength="150"
                    placeholder="https://instagram.com/USUARIO"
                  ></b-form-input>
                </b-form-group>

                <b-form-group description label="Twitch (link)">
                  <b-form-input
                    v-model="team.social_twitch"
                    type="url"
                    maxlength="150"
                    placeholder="https://twitch.tv/USUARIO"
                  ></b-form-input>
                </b-form-group>

                <b-form-group description label="Gamersclub (link)">
                  <b-form-input
                    v-model="team.social_gamersclub"
                    type="url"
                    maxlength="150"
                    placeholder="https://gamersclub.com.br/times/000000"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  description
                  label="Level do time na Gamersclub (não minta cara, sabemos o que está fazendo :D)"
                >
                  <b-form-input
                    v-model="team.gamersclub_level"
                    type="number"
                    maxlength="2"
                    min="0"
                    max="20"
                    placeholder="https://gamersclub.com.br/times/000000"
                  ></b-form-input>
                </b-form-group>
              </form>
            </b-modal>
          </div>

          <hr>
          <b-button
            variant="outline-danger"
            block
            @click.stop.prevent="leaveTeam"
            v-if="team.user_is_player"
          >Sair do time</b-button>

          <b-button block v-b-modal.modalJoinTeam v-if="!team.user_is_player">Entrar no time</b-button>
          <b-modal
            v-if="!team.user_is_player"
            id="modalJoinTeam"
            title="Entrar no time"
            ref="modalJoinTeam"
            @ok="handleOk"
            @shown="clearPassword"
          >
            <p class="my-4">Informe abaixo o código recebido do dono do time</p>
            <form @submit.stop.prevent="handleSubmit">
              <b-form-input type="text" placeholder="Digite o código" v-model="team_password"></b-form-input>
            </form>
          </b-modal>

          <!-- <hr> -->

          <b-button block v-b-modal.modalSchedule v-if="userCanScheduleGame">Marcar jogo</b-button>
          <b-modal
            id="modalSchedule"
            title="Marcar Jogo"
            ref="modalSchedule"
            @ok="handleScheduleOk"
          >
            <form @submit.stop.prevent="handleScheduleSubmit">
              <b-form-group description label="Seu time">
                <b-form-select required v-model="schedule.team_a" class="mb-3">
                  <option
                    v-for="team in currentUserTeams"
                    :key="team.id"
                    :value="team.slug"
                  >{{ team.name }}</option>
                </b-form-select>
              </b-form-group>

              <b-form-group description label="Formato">
                <b-form-select required v-model="schedule.players_per_team" class="mb-3">
                  <option value="5">5x5</option>
                  <option value="2">3x3</option>
                  <option value="1">1x1</option>
                </b-form-select>
              </b-form-group>

              <!-- <b-form-group description="" label="Mapa">
                <b-form-select required v-model="schedule.map" class="mb-3">
                  <option>de_inferno</option>
                  <option>de_dust2</option>
                  <option>de_mirage</option>
                  <option>de_cache</option>
                  <option>de_overpass</option>
                  <option>de_cbble</option>
                  <option>de_train</option>
                  <option>de_nuke</option>
                </b-form-select>
              </b-form-group>-->

              <b-form-group
                description
                label="Jogar 30 rounds (modo treino)?"
                v-b-tooltip.hover
                title="apenas usuários PREMIUM"
              >
                <b-form-select
                  :disabled="!currentUser.is_premium"
                  v-model="schedule.is_fullrounds_enabled"
                  class="mb-3"
                >
                  <option value="false">Não, jogar até um time fazer 16 (padrão)</option>
                  <option value="true">Sim, ambos os times jogam 15 rounds de cada lado</option>
                </b-form-select>
              </b-form-group>

              <b-form-group description label="FIGHTBACK Ativo">
                <b-form-select v-model="schedule.is_fightback_enabled" class="mb-3">
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </b-form-select>
              </b-form-group>

              <b-form-group
                description
                label="GOTV"
                v-b-tooltip.hover
                title="apenas usuários PREMIUM"
              >
                <b-form-select
                  :disabled="!currentUser.is_premium"
                  v-model="schedule.is_gotv_enabled"
                  class="mb-3"
                >
                  <option value="false">Não</option>
                  <option value="true">Sim</option>
                </b-form-select>
              </b-form-group>

              <b-form-group description label="Data e Horário">
                <datetime
                  required
                  v-model="schedule.start_time"
                  type="datetime"
                  :min-datetime="minScheduleDate"
                  :max-datetime="maxScheduleDate"
                  :minute-step="10"
                  input-class="form-control"
                  class="mb-3"
                ></datetime>
              </b-form-group>

              <b-form-checkbox
                v-model="schedule.skip_veto"
                :value="true"
                :unchecked-value="false"
              >
                Quero escolher o mapa e pular o veto no servidor
              </b-form-checkbox>

              <b-form-group label="Mapa" v-if="schedule.skip_veto">
                <b-form-radio-group
                  v-model="schedule.map"
                  :options="mapOptions"
                  name="radios-stacked"
                  stacked
                  required
                ></b-form-radio-group>
              </b-form-group>
            </form>
          </b-modal>
        </div>

        <div class="col-12 col-md-9">
          <div class="content">
            <h4>Sobre a equipe</h4>
            <p class="tagline">{{ team.about }}</p>
          </div>

          <LobbiesTable
            :lobbies="team.latest_lobbies"
            v-if="team.latest_lobbies && team.latest_lobbies.length"
          ></LobbiesTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LobbiesTable from "@/components/LobbiesTable";
import PageHeader from "@/components/PageHeader";
import UserCard from "@/components/UserCard";
import myUpload from "vue-image-crop-upload";
import { DateTime } from "luxon";

export default {
  name: "TeamSingle",
  computed: {
    userCanScheduleGame: function() {
      return this.isLoggedIn;
    },
    teamLevel: function() {
      if (this.team.queota_level == "team_rank_a") return "A";
      else if (this.team.queota_level == "team_rank_b") return "B";
      else if (this.team.queota_level == "team_rank_c") return "C";
      else if (this.team.queota_level == "team_rank_d") return "D";
      else if (this.team.queota_level == "team_rank_e") return "E";
      else return "?";
    },
    minScheduleDate: function() {
      // var now = new Date()
      // now.setMinutes(now.getMinutes() + 10)
      // return now.toISOString()
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ minutes: 10 })
        .toISODate();
    },
    maxScheduleDate: function() {
      return DateTime.local()
        .setZone("America/Sao_Paulo")
        .plus({ hours: 32 })
        .toISODate();
    }
  },
  data() {
    return {
      team: { cover: "", avatar: "", members: [], id: 0 },
      team_password: "",
      schedule: {
        team_a: 0,
        map: "de_mirage",
        players_per_team: 5,
        start_time: "",
        is_fightback_enabled: "true",
        is_gotv_enabled: "false",
        is_fullrounds_enabled: "false",
        skip_veto: true
      },
      mapOptions: [
        { text: 'de_mirage', value: 'de_mirage' },
        { text: 'de_inferno', value: 'de_inferno' },
        { text: 'de_dust2', value: 'de_dust2' },
        { text: 'de_vertigo', value: 'de_vertigo' },
        { text: 'de_overpass', value: 'de_overpass' },
        { text: 'de_train', value: 'de_train' },
        { text: 'de_nuke', value: 'de_nuke' }
      ],
      imgDataUrl: "",
      imgCoverDataUrl: "",
      avatarShow: false,
      avatarParams: {
        name: "avatar"
      },
      avatarHeaders: {
        Authorization: localStorage.getItem("token")
      },
      avatarUploadUrl: `${
        window.location.hostname == "queota.club"
          ? "https://api.queota.club"
          : "http://localhost:5000"
      }/teams/${this.$route.params.id}/avatar.json`,
      coverShow: false,
      coverParams: {
        name: "cover"
      },
      coverHeaders: {
        Authorization: localStorage.getItem("token")
      },
      coverUploadUrl: `${
        window.location.hostname == "queota.club"
          ? "https://api.queota.club"
          : "http://localhost:5000"
      }/teams/${this.$route.params.id}/cover.json`,
      currentUserTeams: []
    };
  },
  metaInfo() {
    return {
      title: `${this.team.name}`
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("teams/" + this.$route.params.id + ".json")
        .then(response => {
          this.team = response.data;
          this.imgDataUrl = response.data.avatar.url;
          this.imgCoverDataUrl = response.data.cover.url;
        });

      this.$http.get("pages/my_account.json").then(response => {
        this.currentUserTeams = response.data.teams;
      });
    },
    clearPassword() {
      this.team_password = "";
    },
    handleOk(evt) {
      evt.preventDefault();
      if (!this.team_password) {
        alert("Preencha uma senha");
      } else {
        this.handleSubmit();
      }
    },
    handleSubmit() {
      if (!this.team_password) {
        alert("Preencha uma senha");
      } else {
        this.$http
          .post(`teams/${this.$route.params.id}/join.json`, {
            secret_code: this.team_password
          })
          .then(response => {
            this.$notify({
              group: "all",
              title: "Bem vindo ao time"
            });
            this.$refs.modalJoinTeam.hide();
          })
          .catch(response => {
            this.$refs.modalJoinTeam.hide();
          });
      }
    },
    handleEditSubmit() {
      this.$refs.modalEditTeam.hide();
    },
    handleEditOk() {
      this.$http
        .put(`teams/${this.$route.params.id}.json`, { team: this.team })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Time editado com sucesso!"
          });
          this.$refs.modalEditTeam.hide();
        })
        .catch(response => {
          this.$refs.modalEditTeam.hide();
        });
    },

    handleScheduleSubmit() {
      // this.$refs.modalSchedule.hide()
      this.handleScheduleOk();
    },
    handleScheduleOk() {
      if (this.schedule.team_a == 0) {
        return;
      }
      this.$http
        .post(`teams/${this.$route.params.id}/schedule.json`, this.schedule)
        .then(response => {
          this.$refs.modalSchedule.hide();
          this.$notify({
            group: "all",
            title: "Proposta enviada para o time"
          });
        })
        .catch(response => {
          this.$refs.modalSchedule.hide();
        });
    },

    avatarToggleShow() {
      this.avatarShow = !this.avatarShow;
    },
    avatarCropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
    },
    avatarCropUploadSuccess(jsonData, field) {
      // this.imgDataUrl = jsonData.avatar.url
      this.$notify({
        group: "all",
        title: "Avatar alterado com sucesso"
      });
    },
    avatarCropUploadFail(status, field) {
      this.imgDataUrl = this.team.avatar.url;
    },

    coverToggleShow() {
      this.coverShow = !this.coverShow;
    },
    coverCropSuccess(imgDataUrl, field) {
      this.imgCoverDataUrl = imgDataUrl;
    },
    coverCropUploadSuccess(jsonData, field) {
      // this.imgDataUrl = jsonData.cover.url
      this.$notify({
        group: "all",
        title: "Cover alterado com sucesso"
      });
    },
    coverCropUploadFail(status, field) {
      this.imgCoverDataUrl = this.team.cover.url;
    },

    kickPlayer(playerSlug) {
      if (
        confirm(
          "Você tem certeza que deseja kickar este jogador?\nAVISO: Essa ação não tem retorno."
        )
      ) {
        this.$http
          .get(`teams/${this.$route.params.id}/kick.json?slug=${playerSlug}`)
          .then(response => {
            this.$notify({
              group: "all",
              title: "Usuário kickado com sucesso"
            });
            this.initialize();
          });
      }
    },

    leaveTeam() {
      if (
        confirm(
          "Tem certeza que deseja deixar o time?\nAVISO: Essa ação não tem retorno."
        )
      ) {
        this.$http
          .get(`teams/${this.$route.params.id}/leave.json`)
          .then(response => {
            this.$notify({
              group: "all",
              title: "Você saiu do time"
            });
            this.initialize();
          });
      }
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    PageHeader,
    UserCard,
    "my-upload": myUpload,
    LobbiesTable
  }
};
</script>

<style lang="sass" scoped>
.page-header
  width: 100%
  height: 240px
  .header-wrapper
    overflow: hidden
    height: 100%
    position: relative
    img
      width: 100%
      height: 100%
      object-fit: cover

      position: absolute
      z-index: 1
      width: 100%
      height: 100%
      top: 0
      left: 0
    .overlay-mask
      background: rgba(0, 0, 0, .6)
      position: absolute
      z-index: 2
      width: 100%
      height: 100%
      top: 0
      left: 0

      display: flex
      justify-content: flex-end
      align-items: bottom

      .container
        display: flex
        align-items: flex-end
        justify-content: flex-end
        text-align: right
        color: rgba(255, 255, 255, .5)

      .roster
        .members-list
          display: flex
          flex-wrap: wrap
          // justify-content: space-between
          > div
            border-radius: 100%
            position: relative

          .kick-player
            position: absolute
            bottom: 0
            left: 0
            font-size: 12px
            padding: 2px 4px
            background: rgba(255, 33, 33, .4)
            border: 0

.stats-bar
  border-top: 1px solid #333
  border-bottom: 1px solid #111
  background: #333
  background: linear-gradient(0deg, rgba(49,49,49,1) 15%, rgba(29,29,29,1) 80%, rgba(17,17,17,1) 90%)
  .stats-bar-content
    padding: 10px 0
    color: white

    .stats-box
      display: flex
      // justify-content: space-between
      .stat-box
        // width: 30%
        &:not(:first-child)
          margin-left: 20px
        p
          margin: 0
          display: inline-block
          color: rgba(255, 255, 255, .8)
          &:hover
            color: rgba(255, 255, 255, 1)
        p.heading
          text-transform: uppercase
          text-align: center
          font-size: 13px
          margin-right: 5px
        p.title
          text-align: center
          font-weight: bold
          font-size: 20px

.team-name
  word-break: break-all

.content
  margin: 20px 0

.social-media-links
  margin-bottom: 20px
  display: flex
  a
    width: 32px
    height: 32px
    background: #aaa
    display: flex
    justify-content: center
    align-items: center
    border-radius: 4px
    transition: all .3s
    color: #333

    &:not(:first-child)
      margin-left: 5px

    &:hover
      text-decoration: none
      background: #333
      color: white

    span
      display: none

.profile-avatar-container
  position: relative
  width: 100%
  height: auto
  min-height: 255px
  margin-top: -100px
  z-index: 2
  .profile-image
    position: absolute

  .profile-avatar-actions
    display: none
  &:hover
    .profile-avatar-actions
      position: absolute
      width: 100%
      height: 100%
      background: rgba(0, 0, 0, .4)

      border-radius: 250%

      display: flex
      justify-content: center
      align-items: center

      a
        color: white
        &:hover
          text-decoration: underline
@media (max-width: 600px)
  .profile-avatar-container
    position: relative
    margin: auto
    min-height: 360px
</style>
